// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){
 
  //wait until images, links, fonts, stylesheets, and js is loaded
  window.addEventListener("load", function() {

    const allSwiperSlides = document.querySelectorAll('.swiper');
    allSwiperSlides.forEach(function(swiper) {
      const swiperOptions = JSON.parse(swiper.getAttribute('data-swiper'));
      /* Slider initialisieren */
      const swiperInstance = new Swiper(swiper, swiperOptions);
    });
   }, false);
 
 });